module.exports = __webpack_public_path__ + "img/24_62.333b8b3b.png";